<!-- start compare fund section -->
<section class="FT-comparefund-heading">
  <div class="container">
    <div class="row gx-3">
      <div class="comapre-fund col-lg-auto makeLeft">
        <ng-container *ngIf="!isMobileAddClicked else showMobileGoBack">
          <div class="d-md-none mb-2" style="margin-top: 30px;">
            <a style="cursor: pointer;" (click)="backClicked()">
              <img alt="image" src="assets/images/general/arrowleft.webp">
              <img alt="image" src="assets/images/fund/Vec.svg" class="mobile-icons dark-mode-icon"
                   style="width: 20px;">
            </a>
          </div>
          <h3 class="filter-title">{{ "products.compare-mutual-funds-heading" | translate }}</h3>
          <p *ngIf="isLoaded && fundsData?.length">
            {{ "products.compare-mutual-funds-subHeading" | translate }}
          </p>
        </ng-container>
        <ng-template #showMobileGoBack>
          <div class="d-md-none mb-2" style="margin-top: 30px;">
            <a (click)="mobileAddFundGoBack()">
              <img alt="image" src="assets/images/general/arrowleft.webp">
              <img alt="image" src="assets/images/fund/Vec.svg" class="mobile-icons dark-mode-icon"
                   style="width: 20px;">
            </a>
          </div>
        </ng-template>
      </div>
      <div class="add-fund-btn my-3" style="display: flex; justify-content: end;"
           *ngIf="isLoaded && fundsData?.length && !isMobileAddClicked && !(fundsData?.length > 2)">
        <button class="d-none d-md-block btn btn-primary" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample" (click)="makeCartToggleWeb()">
          {{ "products.compare-add-fund-button-label" | translate }}
        </button>
        <button style="font-weight: 500; color: #fff;" class="d-md-none btn btn-primary" (click)="makeCartToggleWeb()">
          {{ "products.compare-add-fund-button-label" | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="isLoaded === undefined && fundsData?.length !== 0">
      <div class="text-center mb-5 mt-5">
        <div id="loader">
          <img src="assets/images/home/loader.gif" alt="Loading...">
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Code goes here for comparison if local storage has funds-->
<ng-container *ngIf="!isMobileAddClicked && isLoaded && fundsData?.length > 0">
  <section class="makeCompareMutualColor" id="maincompare">
    <div class="container">
      <div class="">
        <div class="FT-comparefund-wrapper">
          <table>
            <tr>
              <th>
                <h2 *ngIf="fundsData?.length > 1">{{ "products.fundsCompareing" | translate }}
                  {{ fundsData?.length }}
                  {{ "products.fundsCompareLable" | translate }}</h2>
                <h2 *ngIf="fundsData?.length == 1">Add more funds to compare</h2>
              </th>

              <!-- Fund Card -->
              <th *ngFor="let fundData of fundsData; let fundIndex = index">
                <div class="fund-card-wrap">
                  <button class="fund-cancel" (click)="removeFund(fundIndex, fundData.fundId, fundData.fundName)">
                    &#10005;
                  </button>
                  <div class="fund-card-top">
                    <div class="fund-card-title">
                      <div>
                        <a [href]="fundData.fundLink">{{ fundData.fundName }}</a>
                      </div>
                    </div>
                    <!--<div class="three-dot">
                      <i class="bi bi-three-dots-vertical"></i>
                    </div>-->
                  </div>
                  <div class="fund-card-title-action">
                    <!--<button class="cart-btn" (click)="goToCart()">
                      <img alt="image" src="assets/images/general/cart-icon.svg">
                    </button>-->
                    <button (click)="onInvestNow(fundData.fundName, fundData.fundId)" class="invest-now-btn">
                      {{ "products.fund-listing-button-invest-now" | translate }}
                    </button>
                  </div>
                </div>
              </th>
              <!-- <th *ngIf="fundsData?.length < 3">
                 <div class="fund-card-wrap add-fund-btn">
                   <ng-container *ngIf="isMobileView else desktop">
                     <button class="d-md-block" (click)="makeCartToggleWeb()">
                       {{ "products.compare-add-fund-button-label" | translate }}
                     </button>
                   </ng-container>
                   <ng-template #desktop>
                     <button class="d-md-block" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
                             aria-controls="offcanvasExample" (click)="makeCartToggleWeb()">
                       {{ "products.compare-add-fund-button-label" | translate }}
                     </button>
                   </ng-template>
                   &lt;!&ndash;<button class="d-md-none cart-icon" (click)="makeCartToggleWeb()" style="font-weight: 500; color: #3769FF;">
                     {{ "products.add-fund-button-label" | translate }}
                   </button>&ndash;&gt;
                 </div>
               </th>-->
            </tr>
            <tr>
              <td colspan="4"></td>
            </tr>
            <!-- Key highlights -->
            <tr>
              <td>{{ "products.compare-key-highlights" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData.contentData?.fundDescription | ftDashIfEmpty }}
              </td>
            </tr>
            <!-- Fund size -->
            <tr>
              <td>
                {{ "products.compare-fund-size" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                <span *ngIf="fundData?.aumData">
                  {{ "products.compare-aum-of" | translate }}
                  {{
                        fundData.aumData?.totalNetAssets
                            | inrSymbol: "pre"
                            | ftDashIfEmpty
                  }}
                  {{ "products.compare-crores" | translate }}
                  {{ "products.as-of" | translate }}
                  {{ fundData.aumData?.asOfDate | ftDashIfEmpty }}
                </span>
                <span *ngIf="!fundData?.aumData">
                  {{ "" | ftDashIfEmpty }}
                </span>
              </td>
            </tr>
            <!-- Fund inception date-->
            <tr>
              <td>
                {{ "products.compare-fund-inception-date" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData.fundInceptionDate | ftDashIfEmpty }}
              </td>
            </tr>
            <!-- Annualised returns select option -->
            <tr>
              <td>{{ "products.compare-annualized-returns" | translate }}</td>
              <td *ngFor="let fundData of fundsData; let fundIndex = index">
                <ng-container *ngIf="fundData.performanceData">
                  <div>{{ "products.as-of-capitalize" | translate }}
                    {{ fundData.performanceData?.asOfDate | ftDashIfEmpty }}
                  </div>
                  <div class="annualised-returns">
                    <select class="form-select" aria-label="Default select example"
                            value="fundData?.performancePeriodDropdownItems[0]"
                            (change)="getAnnualizedReturnsValue($event.target.value,fundIndex)">
                      <option *ngFor="let plan of fundData?.performancePeriodDropdownItems; let i = index"
                              [attr.value]="plan.assetValue">{{ plan.label }}
                      </option>
                    </select>
                    <div>{{
                            selectedPerformanceValue &&
                            selectedPerformanceValue["fund" + (fundIndex + 1)]
                                ? selectedPerformanceValue["fund" + (fundIndex + 1)]
                                : fundData.performanceData
                                    ?.averageAnnualReturnFor1Year
                      }}%
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!fundData.performanceData">
                  <span>{{ "" | ftDashIfEmpty }}</span>
                </ng-container>
              </td>
            </tr>
            <!-- PRODUCT LABEL - RISK / VOLATILITY -->
            <tr>
              <td>{{ "products.compare-product-label" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                <img alt="image" src="assets/images/general/very-high.webp" style="margin-bottom: 3px">
                {{ getRisk(fundData?.contentData?.productLabel) }}
              </td>
            </tr>
            <!-- Tax implication -->
            <!-- <tr>
              <td>{{ "products.compare-tax-implication" | translate }}</td>
              <td *ngFor="let fundData of fundsData" [innerHTML]="fundData.contentData?.taxImplication | ftDashIfEmpty">
              </td>
            </tr> -->
            <!-- Type of scheme and % of equity exposure -->
            <tr>
              <td>
                {{ "products.compare-type-of-scheme" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                <div>{{ fundData.contentData?.schemeType | ftDashIfEmpty }}</div>
                <div><strong>{{ "products.compare-exposure" | translate }}</strong></div>
                <ng-container *ngIf="fundData.portfolioData?.equityExposureData">
                  <div *ngFor="let exposureData of fundData.portfolioData.equityExposureData"
                       class="lr-justify-details">
                    <div>{{ exposureData.name }}</div>
                    <div>{{ exposureData.valueAsPercentage }}</div>
                  </div>
                </ng-container>
                <div class="lr-justify-details" *ngIf="!fundData.portfolioData?.equityExposureData">
                  {{ "" | ftDashIfEmpty }}
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ "products.fundCompareCategory" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData.assetClass }}, {{ fundData.invfocus }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.fundCompareFundAge" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData?.fundInceptionDate | yearsOld }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.fundCompareInvestors" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData.contentData?.uniqueInvestors }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.fundCompareTop3Sectors" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                <ng-container *ngIf="fundData?.portfolioData?.sectorAllocation.length >0; else blank">
                  <div *ngFor="let fundThreeSector of getTopholding(fundData.portfolioData?.sectorAllocation, 3)">
                    {{ fundThreeSector.sectorname }} ({{ fundThreeSector.brkdwnpct }}%)
                  </div>
                </ng-container>

                <ng-template #blank>
                  <span> - </span>
                </ng-template>
              </td>
            </tr>
            <tr>
              <td>{{ "products.fundCompareTop5Holdings" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                <ng-container *ngIf="fundData?.portfolioData?.topTenHoldings.length >0; else blank">
                  <div *ngFor="let fundToptenData of getTopholding(fundData.portfolioData?.topTenHoldings, 5)">
                    {{ fundToptenData.hldngname }} ({{ fundToptenData.brkdwnpct }}%)
                  </div>
                </ng-container>

                <ng-template #blank>
                  <span> - </span>
                </ng-template>
              </td>
            </tr>
            <!-- Load structure -->
            <tr>
              <td>
                {{ "products.compare-load-structure" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                <div class="flex-container space-bottom">
                  <div class="width-full">
                    {{ "products.compare-entry-load" | translate }}
                  </div>
                  <div class="width-full">
                    {{ fundData.contentData?.entryLoad | ftDashIfEmpty }}
                  </div>
                </div>
                <div class="flex-container">
                  <div class="width-full">
                    {{ "products.compare-exit-load" | translate }}
                  </div>
                  <div class="width-full" [innerHTML]="
                        fundData.contentData?.exitLoad | ftDashIfEmpty
                      "></div>
                </div>
              </td>
            </tr>
            <!-- Minimum investment -->
            <tr>
              <td>
                {{ "products.compare-minimum-investment" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                <div class="flex-container">
                  <div class="width-full">
                    {{
                          "products.compare-minimum-investment-desc-text"
                              | translate
                    }}
                  </div>
                  <div class="width-half">
                    {{ fundData.minimumInvestment | ftDashIfEmpty }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- Additional investment -->
            <tr>
              <td>
                {{ "products.compare-additional-investment" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                <div class="flex-container">
                  <div class="width-full">
                    {{
                          "products.compare-additional-investment-desc-text"
                              | translate
                    }}
                  </div>
                  <div class="width-half">
                    {{ fundData.additionalInvestment | ftDashIfEmpty }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- Relevant ratios -->
            <tr>
              <td>
                {{ "products.compare-relevant-ratios" | translate }}
              </td>
              <td *ngFor="let fundData of fundsData">
                {{ "products.compare-expense-ratio" | translate }}&nbsp;-&nbsp;
                {{ fundData.chargesData?.expenseRatio | ftDashIfEmpty }}<br>
                {{ "products.compare-expense-ratio-direct" | translate }}&nbsp;-&nbsp;
                {{ fundData.chargesData?.expenseRatioDirect | ftDashIfEmpty }}<br>
                {{ "products.compare-portfolio-turnover-ratio" | translate }}&nbsp;-&nbsp;
                {{ fundData.portfolioData?.turnoverRatio | ftDashIfEmpty }}<br>
                {{ "products.compare-relevant-ratios-desc-text" | translate }}
              </td>
            </tr>
            <!-- Suitable for -->
            <tr>
              <td> {{ "products.compare-suitable-for" | translate }}</td>
              <td *ngFor="let fundData of fundsData">
                {{ fundData.contentData?.suitableFor?.join(", ") | ftDashIfEmpty }}
              </td>
            </tr>

            <!-- Recent dividends -->
            <tr>
              <td>{{ "products.compare-recent-dividends" | translate }}</td>
              <td *ngFor="let fundData of fundsData; let fundIndex = index">
                <div *ngIf="fundData.dividendData">{{ "products.compare-plan" | translate }}:</div>
                <ng-container *ngIf="fundData.portfolioData?.equityExposureData">
                  <span *ngIf="fundData.dividendData">
                    <select class="form-select" aria-label="Default select example"
                            (change)="handleDividendPlanSelection($event, fundIndex)">
                      <option *ngFor="let dividend of fundData.dividendData" [attr.value]="dividend.planName">
                        {{ dividend.planName }}
                      </option>
                    </select>
                  </span>
                  <span *ngIf="!fundData.dividendData"> - </span>
                  <div class="lr-justify-details" *ngIf="fundData?.dividendData !== null">
                    <div>{{ "products.idcw-card-row-recordDate" | translate }}</div>
                    <div>{{
                            fundData?.dividendData[
                                selectedPlanIndex["fund" + (fundIndex + 1)]
                                ].recordDate | ftDashIfEmpty
                      }}
                    </div>
                  </div>
                  <div class="lr-justify-details" *ngIf="fundData?.dividendData !== null">
                    <div>{{
                            "products.idcw-card-row-distributionAmount" | translate
                      }}
                    </div>
                    <div>{{
                            fundData?.dividendData[
                                selectedPlanIndex["fund" + (fundIndex + 1)]
                                ].distributionAmount | ftDashIfEmpty
                      }}
                    </div>
                  </div>
                  <div class="lr-justify-details" *ngIf="fundData?.dividendData !== null">
                    <div>{{
                            "products.idcw-card-row-recordNav" | translate
                      }}
                    </div>
                    <div>{{
                            fundData?.dividendData[
                                selectedPlanIndex["fund" + (fundIndex + 1)]
                                ].recordNav
                                | inrSymbol: "pre"
                                | ftDashIfEmpty
                      }}
                    </div>
                  </div>
                  <div class="lr-justify-details" *ngIf="fundData?.dividendData !== null">
                    <div>{{
                            "products.idcw-card-row-exDividendDate" | translate
                      }}
                    </div>
                    <div>{{
                            fundData?.dividendData[
                                selectedPlanIndex["fund" + (fundIndex + 1)]
                                ].exDividendDate | ftDashIfEmpty
                      }}
                    </div>
                  </div>
                  <div class="lr-justify-details" *ngIf="fundData?.dividendData !== null">
                    <div>{{
                            "products.idcw-card-row-exDividendNav" | translate
                      }}
                    </div>
                    <div>{{
                            fundData?.dividendData[
                                selectedPlanIndex["fund" + (fundIndex + 1)]
                                ].exDividendNav
                                | inrSymbol: "pre"
                                | ftDashIfEmpty
                      }}
                    </div>
                  </div>
                </ng-container>
                <div class="lr-justify-details" *ngIf="!fundData.portfolioData?.equityExposureData">
                  {{ "" | ftDashIfEmpty }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</ng-container>


<!-- Code goes here for empty page if local storage has No funds-->
<!-- isLoaded -->
<ng-container *ngIf="fundData && !isAddFundData && fundsData?.length === 0">
  <section class="FT-all-funds watchlist-funds empty-watchlist">
    <ft-empty-page
        [brConfiguration]="brConfiguration"
        [fundData]="fundData"
        [sideFilterOptions]="sideFilterOptions"
        [comaredCardImg]="true"
        [cardTypeData]="'EMPTY_COMPARE'"
        [addFundData]="false"
        pageSubHeading="{{ 'products.empty-page-subHeading' | translate }}">
    </ft-empty-page>
  </section>
</ng-container>

<div *ngIf="!isMobileView">
  <div class="offcanvas offcanvas-end custom-offcanvas" tabindex="-1" id="offcanvasExample"
       aria-labelledby="offcanvasExampleLabel" style="z-index: 100000;">
    <div class="offcanvas-body darkOffcanvasAddbody">
      <div class="d-flex justify-content-between mt-2" style="padding: 4px 31px;">
        <div class="cardAdd">{{ "products.add-compare-fund-label" | translate }}</div>
        <div type="button" data-bs-dismiss="offcanvas" aria-label="Close">
          <img alt="image" src="./assets/images/comparefund/Frame 1000007569.png">
        </div>
      </div>
      <ng-container *ngIf="getAddFund">
        <ft-empty-page
            [fundData]="fundData"
            [brConfiguration]="brConfiguration"
            [sideFilterOptions]="sideFilterOptions"
            [fundCompareIds]="fundCompareIds"
            [comaredCardImg]="false"
            [cardTypeData]="'EMPTY_COMPARE'"
            [addFundData]="true"
            pageSubHeading="{{ 'products.empty-page-subHeading' | translate }}">
        </ft-empty-page>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="isMobileView && isMobileAddClicked && getAddFund">
  <ft-empty-page
      [brConfiguration]="brConfiguration"
      [fundData]="fundData"
      [sideFilterOptions]="sideFilterOptions"
      [fundCompareIds]="fundCompareIds"
      [comaredCardImg]="false"
      [cardTypeData]="'EMPTY_COMPARE'"
      [addFundData]="true"
      [isMobileAdd]="true"
      pageSubHeading="{{ 'products.empty-page-subHeading' | translate }}">
  </ft-empty-page>
</ng-container>
